export default __webpack_public_path__ + "static/media/colored-offer-publish-icon.542ab35c.svg";